import(/* webpackMode: "eager" */ "/vercel/path0/apps/proportals/src/app/(unauthenticated)/error.tsx");
